import { NewRelicParmsInt, NewRelicParmsOldInt } from "@app/interfaces/ga4.interface";
import { Passenger } from "@app/models/micro";
import { Passenger as PassengerOld } from "@app/models";
import { HttpHeaders, HttpResponse } from "@angular/common/http";
import moment from "moment";
type Enviroment = 'production' | 'cert';
export class NewRelicMetricModel {
  actionSubname: string = '';
  enviroment: Enviroment = 'cert';
  kioskID: string = 'kiosk';
  isAgency: boolean = false;
  ffN: string;
  legEntity: string;
  legCode: string;
  legRegion: string;
  microRequest;
  microResponse;
  name: string;
  reservationCode: string;
  resultState: number;
  route: string;
  storefront: string;
  tier: string;
  totalPassengers: number;
  transactionId: string;
  tripType: string;
  url: string;
  warnings: any;
  departure: string
  arrival: string;
  isDomestic: boolean = false;
  kioskDate: string;
  headers: any;
  bodyRequest: any;
  passengerId: string;
  isError: string;
  bookedLegCollection;
  passengers: any;
  travelDoc: any;
  isSeamless: boolean = false;
  QMReplayLinkKiosk = '';

  constructor() {

  }

  build({
    name,
    url,
    kioskID,
    reservation,
    transactionId,
    enviroment,
    microRequest,
    microResponse,
    admin,
    passengerId,
    isError,
    route,
    bookedLegCollection,
    passengers,
    travelDoc,
    QMReplayLinkKiosk,
  }: NewRelicParmsInt) {

    this.QMReplayLinkKiosk = QMReplayLinkKiosk || '';
    this.travelDoc = travelDoc;
    this.passengers = passengers;
    this.passengerId = passengerId;
    this.isError = isError;
    this.route = route;
    this.actionSubname = name;
    this.name = name;
    this.url = url;
    this.enviroment = enviroment ? 'production' : 'cert';
    this.kioskID = kioskID
    this.microRequest = microRequest;
    this.microResponse = microResponse.body;
    this.resultState = microResponse.status
    this.transactionId = transactionId;
    this.warnings = microResponse.status >= 200 && microResponse.status < 300 ? this.getWarnings(microResponse) : null;
    this.kioskDate = moment().format('YYYY-MM-DD HH:mm:ss')
    this.bookedLegCollection = bookedLegCollection;
    if(microRequest) {
      this.headers = this.transformHeaders(microRequest?.headers);
      this.bodyRequest = microRequest?.body || '';
    }
    if (reservation) {
      const { flightSummary, isAgencyReservation, passengers, flightItineraryType } = reservation;

      this.isAgency = isAgencyReservation || false;
      this.tripType = flightItineraryType;
      this.storefront = admin.Location;
      this.reservationCode = reservation.pnr;
      this.isSeamless = reservation?.codeShare ?? false;
      if (flightSummary) {
        const { legCode, legEntity, arrivalAirport, departureAirport,legRegion } = flightSummary;
        this.legCode = legCode;
        this.legEntity = legEntity;
        this.legRegion = legRegion;
        this.arrival = arrivalAirport;
        this.departure = departureAirport;
        this.isDomestic = flightSummary.isDomestic;
      }
      if (passengers) {
        const passenger = this.getFFN(passengers);
        const passengerInfo = passenger?.passengerInfo;
        if (passengerInfo) {

          this.ffN = passengerInfo?.ffNumber;
          this.tier = passengerInfo?.ffTierLevel;
        }
        this.totalPassengers = passengers.length;
      }

    }else{
      const pnr = microRequest?.headers?.get('pnr');
      this.reservationCode = pnr;
    }
    return this;
  }

  buldMonolite({
    name,
    url,
    kioskID,
    reservationM,
    transactionId,
    enviroment,
    microRequest,
    microResponse,
    admin,
    passengerId,
    isError,
    QMReplayLinkKiosk,
  }: NewRelicParmsOldInt) {
    this.QMReplayLinkKiosk = QMReplayLinkKiosk || '';
    this.passengerId = passengerId;
    this.isError = isError;
    this.actionSubname = name;
    this.name = name;
    this.url = url;
    this.enviroment = enviroment ? 'production' : 'cert';
    this.kioskID = kioskID
    this.microRequest = microRequest;
    this.microResponse = microResponse.body;
    this.resultState = microResponse.status
    this.transactionId = transactionId;
    this.warnings = microResponse.status >= 200 && microResponse.status < 300 ? this.getWarnings(microResponse) : '';
    this.kioskDate = moment().format('YYYY-MM-DD HH:mm:ss')
    if (reservationM) {
      const { flightSummary, passengers, flightItineraryType } = reservationM;

      this.isAgency = false;
      this.tripType = flightItineraryType;
      this.storefront = admin.Location;
      this.reservationCode = reservationM.pnr;

      if(microRequest) {
        this.headers = this.transformHeaders(microRequest?.headers);
        this.bodyRequest = JSON.stringify(microRequest?.body) || '';
      }


      if (flightSummary) {
        const { legCode, isDomestic, arrivalAirport, departureAirport,legEntity } = flightSummary;
        this.legEntity = isDomestic ? 'DOM' : 'INT';
        this.legCode = legCode;
        this.legRegion = reservationM.legRegion;
        this.arrival = arrivalAirport;
        this.departure = departureAirport;
        this.isDomestic = isDomestic;
      }
      if (passengers) {
        const passenger = this.getFFNOld(passengers);
        if (passenger) {
          this.ffN = passenger?.frequentFlyerNumber;
          this.tier = passenger.frequentFlyerProgram;
        }
        this.totalPassengers = passengers.length;
      }

    }
    return this;
  }

  private getFFNOld(PassengersOld: PassengerOld[]): PassengerOld {
    return PassengersOld?.find(passenger => passenger.frequentFlyerNumber !== undefined && passenger.frequentFlyerNumber !== '' && passenger.frequentFlyerNumber !== null);
  }

  private getFFN(passengers: Passenger[]): Passenger {
    return passengers?.find(passenger => passenger.frequentFlyerProgram !== undefined && passenger.frequentFlyerProgram !== '' && passenger.frequentFlyerProgram !== null);
  }

  private getWarnings(response: HttpResponse<any>) {
    let warningsResp: any = [];
    const { body } = response;
    if (body?.hasOwnProperty('warnings')) {
      if (body.warnings?.length > 0) {
        warningsResp = body.warnings;
      }

    }
    return warningsResp?.length > 0 ? warningsResp : null;
  }

  transformHeaders(headers: HttpHeaders) {
    if(headers) {
      let elements = {}
      for (let key of headers.keys()) {
        elements[key] = headers.get(key);
      }
      return elements;
    }
    return null;

  }

}
